<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId")
      button.button.success(slot="trigger", v-if="item && !item.component") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      RegistrationTokenForm(v-model="body")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import StartEndTimePicker from './StartEndTimePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'
import SelectizePlan from "../../components/structure/ui/lists/selectize/SelectizePlan";
import SelectizeFederation from "../../components/structure/ui/lists/selectize/SelectizeFederation";
import RegistrationTokenForm from "../../components/structure/forms/RegistrationTokenForm.vue";
import {EventBus, ReloadList} from "../../eventBus";

export default {
  name: 'RegistrationTokenReveal',
  components: {
    RegistrationTokenForm,
    SelectizeFederation,
    SelectizePlan, SelectizeCommonCost, ActionButton, ModalReveal, StartEndTimePicker, DatePicker
  },
  data() {
    return {

      body: {
        token: null,
        destination_type: null,
        destination_id: null,
        additional: [],
      },

    }
  },
  created() {
  },
  methods: {
    save() {
      return KeplerBackofficeSdk.registrationTokens.make(this.body, () => {
        MaggieHelper.notification('', 'token created')
        this.body = {}
        this.$refs[this.componentId].close()
        EventBus.$emit('reload-list')
      })
    },
  },
  computed: {
    componentId() {
      return this.item !== null ? `token-${this.item.id}` : `token-${this._uid}`
    },
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    type: {
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RegistrationTokenReveal.vue?5f636a32